export const IMAGE_ELEMENT = 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.ImageElement';
